export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Запит в технічну підтримку"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["від"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Чат"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Додати повідомлення"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Файли"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ви можете завантажити один або декілька файлів. Максимальний розмір файлу - 10МБ."])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Текст повідомлення"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Відправити"])}
}